import styled, { css } from "styled-components";
import { useDesignTokens } from "@boi/react-design-tokens";

import type { LinkBaseDisplay } from "./LinkBase.types";

type ContainerProps = {
  $display: LinkBaseDisplay;
};

export const Container = styled.a<ContainerProps>`
  ${({ $display }) => {
    const { tokens } = useDesignTokens();
    const { link } = tokens;

    return css`
      all: unset;
      display: ${$display};
      color: ${link.color.base};
      cursor: pointer;

      &:hover {
        color: ${link.color.hover};
      }

      &:active {
        color: ${link.color.active};
      }

      &:focus-visible {
        outline-width: ${link.focusRing.width};
        outline-style: ${link.focusRing.style};
        outline-color: ${link.focusRing.color};
        outline-offset: ${link.focusRing.offset};
        border-radius: ${link.focusRing.radius};
      }
    `;
  }}
`;
